export default __webpack_public_path__ + "static/assets/199c103c3f733032aecdbfa23da0a255.png";